import { Loader2 } from 'lucide-react';
import type { ButtonProps } from '~/common/components/ui/button';
import { Button } from '~/common/components/ui/button';
import { cn } from '~/common/utils/styleUtil';

type Props = ButtonProps & { inProgress: boolean };

export default function ProgressButton({ inProgress, className, children, ...restProps }: Readonly<Props>) {
  return (
    <Button className={cn(className)} disabled={inProgress} {...restProps}>
      <span className={'contents'}>{inProgress && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}</span>
      {children}
    </Button>
  );
}
